module.exports = __webpack_public_path__ + "static/media/alert.26c6a4c5.wav";


//////////////////
// WEBPACK FOOTER
// ./src/resource/rentaldevice/alert.wav
// module id = 1074
// module chunks = 1